// $("[href^='#']").click(function() {
//     id=$(this).attr("href")
//     $('html, body').animate({
//         scrollTop: $(id).offset().top
//     }, 1000);
//   });


$(document).ready(function () {
    $('a[href*="#"]').on("click", function (event) {
        var href = $(this).attr("href");
        // Only handle if href contains a hash and is not just "#"
        if (href && href.indexOf("#") !== -1 && href !== "#") {
            var anchor = href.substring(href.indexOf("#"));
            var baseUrl = href.split("#")[0];
            var currentPath = window.location.pathname.replace(/\/$/, "");
            var linkPath = $("<a>").attr("href", href)[0].pathname.replace(/\/$/, "");

            // If the link is to a different page (or different path), redirect and scroll after load
            if (baseUrl && baseUrl !== "" && linkPath !== currentPath) {
                localStorage.setItem("scrollToSection", anchor);
                window.location.href = baseUrl + anchor;
                event.preventDefault();
            } else {
                // Same page, smooth scroll
                event.preventDefault();
                smoothScroll(anchor);
            }
        }
    });
    

        function smoothScroll(section) {
        if ($(section).length) {
            $("html, body").animate(
                { scrollTop: $(section).offset().top },
                800, 
                "swing" 
            );
        }
    }
    if (localStorage.getItem("scrollToSection")) {
        let section = localStorage.getItem("scrollToSection");
        localStorage.removeItem("scrollToSection"); 

        setTimeout(function () {
            smoothScroll(section);
        }, 5000); 
    }
});




